import { useEffect, useState } from "react";

const BASE = process.env.REACT_APP_BACKEND_URL;

export async function apiGet(path) {
  const r = await fetch(`${BASE}/api${path}`);
  const j = await r.json().catch(() => ({}));
  if (!r.ok) {
    const err = new Error(j.error || "API_ERROR");
    err.status = r.status;
    err.payload = j;
    throw err;
  }
  return j;
}

export const wsStreamUrl = () => `${BASE.replace(/^http/, "ws")}/api/ws/stream`;

export function timeAgo(ts) {
  if (!ts) return "—";
  const s = Math.max(0, Math.floor(Date.now() / 1000 - ts));
  if (s < 5) return "just now";
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  return `${Math.floor(s / 3600)}h ago`;
}

export function usePolling(path, intervalMs = 8000) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let dead = false;
    const load = async () => {
      try {
        const d = await apiGet(path);
        if (!dead) { setData(d); setError(false); }
      } catch {
        if (!dead) setError(true);
      }
    };
    load();
    const id = setInterval(load, intervalMs);
    return () => { dead = true; clearInterval(id); };
  }, [path, intervalMs]);
  return { data, error };
}
